import { Employee } from '@shared/models/employee.model';

export type AttachmentLibraryGroupName = 'photos' | 'videos' | 'documents';

export interface ProjectAttachmentSource {
  type:
    | 'task'
    | 'comment'
    | 'protocol-entry'
    | 'project_entry_wysiwyg'
    | 'project_description_wysiwyg'
    | 'site_diary';
  id: number;
  name: string;
}

export interface ProjectAttachmentLibraryItem {
  id: number;
  name: string;
  type: string;
  file: string;
  size: number;
  created: string;
  isImage: boolean;
  isVideo: boolean;
  hasPoster: boolean;
  mediaStatus: 1 | 2 | 3 | null;
  metadata?: { width?: number; height?: number; aspectRatio?: number };
  creator?: Employee;
  source?: ProjectAttachmentSource | null;
}

export interface ProjectAttachmentLibraryGroup {
  records: ProjectAttachmentLibraryItem[];
  total: number;
}

export type ProjectAttachmentLibraryResponse = Record<
  AttachmentLibraryGroupName,
  ProjectAttachmentLibraryGroup
>;

export interface ProjectAttachmentLibraryQuery {
  projectIds?: number[];
  search?: string;
  group?: AttachmentLibraryGroupName;
  page?: number;
  records?: number;
}
